import classNames from 'classnames'
import { forwardRef, memo } from 'react'
import Dropdown from 'react-bootstrap/Dropdown'

import { CardListType } from '@/types/card'

import styles from './JumpTo.module.scss'

type CustomDropdownToggleProps = {
  children: React.ReactNode
  onClick: (event: React.MouseEvent<HTMLDivElement, MouseEvent>) => void
}

const CustomDropdownToggle = forwardRef(({ children, onClick }: CustomDropdownToggleProps, ref) => (
  // @ts-ignore
  <div className='cursor-pointer dropdown-toggle ms-1' onClick={onClick} ref={ref}>
    {children}
  </div>
))

CustomDropdownToggle.displayName = 'CustomDropdownToggle'

type Props = {
  cardLists?: CardListType[]
  children: React.ReactNode
  currentElementIndexInViewport?: number
  enableCount?: boolean
  hideHeader?: boolean
  updatedAt: number
}

const JumpTo = ({
  cardLists,
  children,
  currentElementIndexInViewport = 0,
  enableCount,
  hideHeader,
  updatedAt,
}: Props) => {
  // No updatedAt during initial load
  if (!cardLists || cardLists.length === 0 || !updatedAt) {
    return <div className={classNames(styles.container, 'shadow-sm')} />
  }

  // currentElementIndexInViewport and cardLists can briefly be out of sync
  // This ensures that the index is always within bounds
  const index =
    currentElementIndexInViewport >= 0
      ? currentElementIndexInViewport >= cardLists.length
        ? cardLists.length - 1
        : currentElementIndexInViewport
      : 0

  const { header, tag } = cardLists[index]

  return (
    <div className={classNames(styles.container, 'shadow-sm')}>
      {cardLists.length > 1 && (
        <Dropdown>
          {!hideHeader && (
            <Dropdown.Toggle as={CustomDropdownToggle}>
              {header}
              {enableCount && <span> ({cardLists[index].cardviews.length})</span>}
            </Dropdown.Toggle>
          )}
          <Dropdown.Menu>
            {cardLists.map((cardList, i) => {
              const href = i === 0 ? '#cardlists' : cardList.href || `#${cardList.tag}`
              return (
                <Dropdown.Item href={href} key={i}>
                  <span className={classNames({ [styles.active]: cardList.tag === tag })}>{cardList.header}</span>
                </Dropdown.Item>
              )
            })}
          </Dropdown.Menu>
        </Dropdown>
      )}
      <div className='d-flex justify-content-end w-100'>{children}</div>
    </div>
  )
}

export default memo(JumpTo)
